export default function PHP_catch() {
  return (
    <div>
      <h1>PHP_catch</h1>
    </div>
  );
}
